import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

window.CookieConsent = CookieConsent;

const gtag = function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
};

const updateGtagConsent = function(cookie) {
    const categories = cookie.categories || [];

    gtag('consent', 'update', {
        ad_storage: categories.includes('marketing') ? 'granted' : 'denied',
        ad_user_data: categories.includes('marketing') ? 'granted' : 'denied',
        ad_personalization: categories.includes('marketing') ? 'granted' : 'denied',
        analytics_storage: categories.includes('analytics') ? 'granted' : 'denied',
        functionality_storage: categories.includes('functionality') ? 'granted' : 'denied',
        personalization_storage: categories.includes('functionality') ? 'granted' : 'denied'
    });
};

CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: 'cloud inline',
            position: 'bottom center',
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: true,
            flipButtons: false
        }
    },

    cookie: {
        name: 'cc_cookie_azotopower',
        expiresAfterDays: 365
    },

    categories: {
        necessary: {
            enabled: true,
            readOnly: true
        },
        analytics: {},
        marketing: {},
        functionality: {}
    },

    onFirstConsent: function({ cookie }) {
        updateGtagConsent(cookie);
    },

    onConsent: function({ cookie }) {
        updateGtagConsent(cookie);
    },

    onChange: function({ cookie }) {
        updateGtagConsent(cookie);
    },

    language: {
        default: 'pl',
        translations: {
            pl: {
                consentModal: {
                    title: 'Pliki cookies',
                    description: 'Korzystamy z plików cookies i&nbsp;umożliwiamy zamieszczanie ich osobom trzecim. Pliki cookies pozwalają na poznanie Twoich preferencji na podstawie zachowań na stronie. Możesz zaakceptować wszystkie, odrzucić opcjonalne lub dostosować ustawienia. Szczegóły w&nbsp;<a href="https://www.procam.pl/polityka-prywatnosci/" class="cc__link" target="_blank" rel="noopener noreferrer">Polityce Prywatności i&nbsp;Plików Cookies</a>.',
                    acceptAllBtn: 'Akceptuję wszystkie',
                    acceptNecessaryBtn: 'Tylko niezbędne',
                    showPreferencesBtn: 'Ustawienia indywidualne',
                    footer: '<a href="https://www.procam.pl/polityka-prywatnosci/" target="_blank" rel="noopener noreferrer">Polityka prywatności</a>\n<a href="#klauzula" data-cc-glightbox="klauzula">Klauzula informacyjna RODO</a>'
                },
                preferencesModal: {
                    title: 'Ustawienia plików cookies',
                    acceptAllBtn: 'Akceptuję wszystkie',
                    acceptNecessaryBtn: 'Tylko niezbędne',
                    savePreferencesBtn: 'Zapisz ustawienia',
                    closeIconLabel: 'Zamknij',
                    serviceCounterLabel: 'Usługi',
                    sections: [
                        {
                            title: 'Wykorzystanie plików cookies',
                            description: 'Pliki cookies (ciasteczka) to niewielkie informacje tekstowe przechowywane na Twoim urządzeniu. Wykorzystujemy je w&nbsp;celach statystycznych, marketingowych oraz dla zapewnienia prawidłowego działania strony. Poniżej możesz dostosować, które kategorie chcesz zaakceptować. W&nbsp;każdej chwili możesz zmienić swoje ustawienia używając linku „Ustawienia cookies” w&nbsp;stopce strony.'
                        },
                        {
                            title: 'Niezbędne <span class="pm__badge">Zawsze aktywne</span>',
                            description: 'Pliki cookies wymagane do prawidłowego działania strony. Nie można ich wyłączyć.',
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Analityczne',
                            description: 'Pliki cookies wykorzystywane do analizy ruchu na stronie i&nbsp;poznawania sposobu, w&nbsp;jaki użytkownicy z&nbsp;niej korzystają (np. Google Analytics). Pomagają nam ulepszać serwis.',
                            linkedCategory: 'analytics'
                        },
                        {
                            title: 'Marketingowe',
                            description: 'Pliki cookies wykorzystywane do wyświetlania spersonalizowanych reklam oraz mierzenia ich skuteczności (np. Google Ads, Meta Pixel).',
                            linkedCategory: 'marketing'
                        },
                        {
                            title: 'Funkcjonalne',
                            description: 'Pliki cookies umożliwiające dodatkowe funkcje strony, takie jak zapamiętywanie preferencji użytkownika.',
                            linkedCategory: 'functionality'
                        },
                        {
                            title: 'Więcej informacji',
                            description: 'W&nbsp;razie pytań dotyczących wykorzystania plików cookies prosimy o&nbsp;kontakt pod adresem <a href="mailto:rodo@procam.com.pl" class="cc__link">rodo@procam.com.pl</a> lub zapoznanie się z&nbsp;naszą <a href="https://www.procam.pl/polityka-prywatnosci/" class="cc__link" target="_blank" rel="noopener noreferrer">Polityką Prywatności i&nbsp;Plików Cookies</a>.'
                        }
                    ]
                }
            }
        }
    }
});

document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-cc="show-preferences"]');
    if (trigger) {
        e.preventDefault();
        CookieConsent.showPreferences();
        return;
    }

    const ccLink = e.target.closest('a[data-cc-glightbox]');
    if (ccLink) {
        e.preventDefault();
        e.stopPropagation();

        const gallery = ccLink.getAttribute('data-cc-glightbox');
        const externalTarget = document.querySelector(
            `a.js-glightbox[data-gallery="${gallery}"]`
        );

        if (externalTarget && window.glightboxInstance) {
            window.glightboxInstance.open(externalTarget);
        }
    }
});
